
export interface CountryType {
    code: string;
    label: string;
    phone: string;
    length: number;
}

export const countries: CountryType[] = [
    { "code": "AD", "label": "Andorra", "phone": "376", "length": 6 },
    { "code": "AE", "label": "United Arab Emirates", "phone": "971", "length": 9 },
    { "code": "AF", "label": "Afghanistan", "phone": "93", "length": 9 },
    { "code": "AG", "label": "Antigua and Barbuda", "phone": "1-268", "length": 7 },
    { "code": "AI", "label": "Anguilla", "phone": "1-264", "length": 7 },
    { "code": "AL", "label": "Albania", "phone": "355", "length": 8 },
    { "code": "AM", "label": "Armenia", "phone": "374", "length": 8 },
    { "code": "AO", "label": "Angola", "phone": "244", "length": 9 },
    { "code": "AQ", "label": "Antarctica", "phone": "672", "length": 4 },
    { "code": "AR", "label": "Argentina", "phone": "54", "length": 10 },
    { "code": "AS", "label": "American Samoa", "phone": "1-684", "length": 7 },
    { "code": "AT", "label": "Austria", "phone": "43", "length": 12 },
    { "code": "AU", "label": "Australia", "phone": "61", "length": 9 },
    { "code": "AW", "label": "Aruba", "phone": "297", "length": 7 },
    { "code": "AX", "label": "Alland Islands", "phone": "358", "length": 9 },
    { "code": "AZ", "label": "Azerbaijan", "phone": "994", "length": 9 },
    { "code": "BA", "label": "Bosnia and Herzegovina", "phone": "387", "length": 8 },
    { "code": "BB", "label": "Barbados", "phone": "1-246", "length": 7 },
    { "code": "BD", "label": "Bangladesh", "phone": "880", "length": 10 },
    { "code": "BE", "label": "Belgium", "phone": "32", "length": 9 },
    { "code": "BF", "label": "Burkina Faso", "phone": "226", "length": 8 },
    { "code": "BG", "label": "Bulgaria", "phone": "359", "length": 8 },
    { "code": "BH", "label": "Bahrain", "phone": "973", "length": 8 },
    { "code": "BI", "label": "Burundi", "phone": "257", "length": 8 },
    { "code": "BJ", "label": "Benin", "phone": "229", "length": 8 },
    { "code": "BL", "label": "Saint Barthelemy", "phone": "590", "length": 9 },
    { "code": "BM", "label": "Bermuda", "phone": "1-441", "length": 7 },
    { "code": "BN", "label": "Brunei Darussalam", "phone": "673", "length": 7 },
    { "code": "BO", "label": "Bolivia", "phone": "591", "length": 8 },
    { "code": "BR", "label": "Brazil", "phone": "55", "length": 11 },
    { "code": "BS", "label": "Bahamas", "phone": "1-242", "length": 7 },
    { "code": "BT", "label": "Bhutan", "phone": "975", "length": 8 },
    { "code": "BV", "label": "Bouvet Island", "phone": "47", "length": 8 },
    { "code": "BW", "label": "Botswana", "phone": "267", "length": 8 },
    { "code": "BY", "label": "Belarus", "phone": "375", "length": 9 },
    { "code": "BZ", "label": "Belize", "phone": "501", "length": 7 },
    { "code": "CA", "label": "Canada", "phone": "1", "length": 10 },
    { "code": "CC", "label": "Cocos (Keeling) Islands", "phone": "61", "length": 9 },
    { "code": "CD", "label": "Congo, Democratic Republic of the", "phone": "243", "length": 9 },
    { "code": "CF", "label": "Central African Republic", "phone": "236", "length": 9 },
    { "code": "CG", "label": "Congo, Republic of the", "phone": "242", "length": 8 },
    { "code": "CH", "label": "Switzerland", "phone": "41", "length": 9 },
    { "code": "CI", "label": "Cote d'Ivoire", "phone": "225", "length": 8 },
    { "code": "CK", "label": "Cook Islands", "phone": "682", "length": 7 },
    { "code": "CL", "label": "Chile", "phone": "56", "length": 9 },
    { "code": "CM", "label": "Cameroon", "phone": "237", "length": 9 },
    { "code": "CN", "label": "China", "phone": "86", "length": 11 },
    { "code": "CO", "label": "Colombia", "phone": "57", "length": 10 },
    { "code": "CR", "label": "Costa Rica", "phone": "506", "length": 8 },
    { "code": "CU", "label": "Cuba", "phone": "53", "length": 8 },
    { "code": "CV", "label": "Cape Verde", "phone": "238", "length": 8 },
    { "code": "CW", "label": "Curacao", "phone": "599", "length": 7 },
    { "code": "CX", "label": "Christmas Island", "phone": "61", "length": 9 },
    { "code": "CY", "label": "Cyprus", "phone": "357", "length": 8 },
    { "code": "CZ", "label": "Czech Republic", "phone": "420", "length": 9 },
    { "code": "DE", "label": "Germany", "phone": "49", "length": 11 },
    { "code": "DJ", "label": "Djibouti", "phone": "253", "length": 8 },
    { "code": "DK", "label": "Denmark", "phone": "45", "length": 8 },
    { "code": "DM", "label": "Dominica", "phone": "1-767", "length": 7 },
    { "code": "DO", "label": "Dominican Republic", "phone": "1-809", "length": 7 },
    { "code": "DZ", "label": "Algeria", "phone": "213", "length": 9 },
    { "code": "EC", "label": "Ecuador", "phone": "593", "length": 9 },
    { "code": "EE", "label": "Estonia", "phone": "372", "length": 8 },
    { "code": "EG", "label": "Egypt", "phone": "20", "length": 10 },
    { "code": "EH", "label": "Western Sahara", "phone": "212", "length": 9 },
    { "code": "ER", "label": "Eritrea", "phone": "291", "length": 9 },
    { "code": "ES", "label": "Spain", "phone": "34", "length": 9 },
    { "code": "ET", "label": "Ethiopia", "phone": "251", "length": 9 },
    { "code": "FI", "label": "Finland", "phone": "358", "length": 9 },
    { "code": "FJ", "label": "Fiji", "phone": "679", "length": 7 },
    { "code": "FM", "label": "Federated States of Micronesia", "phone": "691", "length": 7 },
    { "code": "FO", "label": "Faroe Islands", "phone": "298", "length": 8 },
    { "code": "FR", "label": "France", "phone": "33", "length": 9 },
    { "code": "GA", "label": "Gabon", "phone": "241", "length": 8 },
    { "code": "GB", "label": "United Kingdom", "phone": "44", "length": 10 },
    { "code": "GD", "label": "Grenada", "phone": "1-473", "length": 7 },
    { "code": "GE", "label": "Georgia", "phone": "995", "length": 9 },
    { "code": "GF", "label": "French Guiana", "phone": "594", "length": 9 },
    { "code": "GG", "label": "Guernsey", "phone": "44-1481", "length": 7 },
    { "code": "GH", "label": "Ghana", "phone": "233", "length": 9 },
    { "code": "GI", "label": "Gibraltar", "phone": "350", "length": 8 },
    { "code": "GL", "label": "Greenland", "phone": "299", "length": 8 },
    { "code": "GM", "label": "Gambia", "phone": "220", "length": 7 },
    { "code": "GN", "label": "Guinea", "phone": "224", "length": 8 },
    { "code": "GP", "label": "Guadeloupe", "phone": "590", "length": 9 },
    { "code": "GQ", "label": "Equatorial Guinea", "phone": "240", "length": 8 },
    { "code": "GR", "label": "Greece", "phone": "30", "length": 10 },
    { "code": "GT", "label": "Guatemala", "phone": "502", "length": 8 },
    { "code": "GU", "label": "Guam", "phone": "1-671", "length": 7 },
    { "code": "GW", "label": "Guinea-Bissau", "phone": "245", "length": 8 },
    { "code": "GY", "label": "Guyana", "phone": "592", "length": 8 },
    { "code": "HK", "label": "Hong Kong", "phone": "852", "length": 8 },
    { "code": "HN", "label": "Honduras", "phone": "504", "length": 8 },
    { "code": "HR", "label": "Croatia", "phone": "385", "length": 9 },
    { "code": "HT", "label": "Haiti", "phone": "509", "length": 8 },
    { "code": "HU", "label": "Hungary", "phone": "36", "length": 9 },
    { "code": "ID", "label": "Indonesia", "phone": "62", "length": 10 },
    { "code": "IE", "label": "Ireland", "phone": "353", "length": 9 },
    { "code": "IL", "label": "Israel", "phone": "972", "length": 9 },
    { "code": "IM", "label": "Isle of Man", "phone": "44-1624", "length": 7 },
    { "code": "IN", "label": "India", "phone": "91", "length": 10 },
    { "code": "IQ", "label": "Iraq", "phone": "964", "length": 9 },
    { "code": "IR", "label": "Iran", "phone": "98", "length": 10 },
    { "code": "IS", "label": "Iceland", "phone": "354", "length": 8 },
    { "code": "IT", "label": "Italy", "phone": "39", "length": 10 },
    { "code": "JE", "label": "Jersey", "phone": "44-1534", "length": 7 },
    { "code": "JM", "label": "Jamaica", "phone": "1-876", "length": 7 },
    { "code": "JO", "label": "Jordan", "phone": "962", "length": 9 },
    { "code": "JP", "label": "Japan", "phone": "81", "length": 10 },
    { "code": "KE", "label": "Kenya", "phone": "254", "length": 9 },
    { "code": "KG", "label": "Kyrgyzstan", "phone": "996", "length": 9 },
    { "code": "KH", "label": "Cambodia", "phone": "855", "length": 9 },
    { "code": "KI", "label": "Kiribati", "phone": "686", "length": 7 },
    { "code": "KM", "label": "Comoros", "phone": "269", "length": 7 },
    { "code": "KN", "label": "Saint Kitts and Nevis", "phone": "1-869", "length": 7 },
    { "code": "KP", "label": "North Korea", "phone": "850", "length": 9 },
    { "code": "KR", "label": "South Korea", "phone": "82", "length": 10 },
    { "code": "KW", "label": "Kuwait", "phone": "965", "length": 8 },
    { "code": "KY", "label": "Cayman Islands", "phone": "1-345", "length": 7 },
    { "code": "KZ", "label": "Kazakhstan", "phone": "7", "length": 11 },
    { "code": "LA", "label": "Laos", "phone": "856", "length": 9 },
    { "code": "LB", "label": "Lebanon", "phone": "961", "length": 8 },
    { "code": "LC", "label": "Saint Lucia", "phone": "1-758", "length": 7 },
    { "code": "LI", "label": "Liechtenstein", "phone": "423", "length": 8 },
    { "code": "LK", "label": "Sri Lanka", "phone": "94", "length": 10 },
    { "code": "LR", "label": "Liberia", "phone": "231", "length": 8 },
    { "code": "LS", "label": "Lesotho", "phone": "266", "length": 8 },
    { "code": "LT", "label": "Lithuania", "phone": "370", "length": 8 },
    { "code": "LU", "label": "Luxembourg", "phone": "352", "length": 8 },
    { "code": "LV", "label": "Latvia", "phone": "371", "length": 8 },
    { "code": "LY", "label": "Libya", "phone": "218", "length": 9 },
    { "code": "MA", "label": "Morocco", "phone": "212", "length": 9 },
    { "code": "MC", "label": "Monaco", "phone": "377", "length": 8 },
    { "code": "MD", "label": "Moldova", "phone": "373", "length": 8 },
    { "code": "ME", "label": "Montenegro", "phone": "382", "length": 8 },
    { "code": "MF", "label": "Saint Martin", "phone": "590", "length": 9 },
    { "code": "MG", "label": "Madagascar", "phone": "261", "length": 9 },
    { "code": "MH", "label": "Marshall Islands", "phone": "692", "length": 7 },
    { "code": "MK", "label": "North Macedonia", "phone": "389", "length": 9 },
    { "code": "ML", "label": "Mali", "phone": "223", "length": 8 },
    { "code": "MM", "label": "Myanmar", "phone": "95", "length": 9 },
    { "code": "MN", "label": "Mongolia", "phone": "976", "length": 8 },
    { "code": "MO", "label": "Macao", "phone": "853", "length": 8 },
    { "code": "MP", "label": "Northern Mariana Islands", "phone": "1-670", "length": 7 },
    { "code": "MQ", "label": "Martinique", "phone": "596", "length": 9 },
    { "code": "MR", "label": "Mauritania", "phone": "222", "length": 8 },
    { "code": "MS", "label": "Montserrat", "phone": "1-664", "length": 7 },
    { "code": "MT", "label": "Malta", "phone": "356", "length": 8 },
    { "code": "MU", "label": "Mauritius", "phone": "230", "length": 8 },
    { "code": "MV", "label": "Maldives", "phone": "960", "length": 7 },
    { "code": "MW", "label": "Malawi", "phone": "265", "length": 8 },
    { "code": "MX", "label": "Mexico", "phone": "52", "length": 10 },
    { "code": "MY", "label": "Malaysia", "phone": "60", "length": 10 },
    { "code": "MZ", "label": "Mozambique", "phone": "258", "length": 9 },
    { "code": "NA", "label": "Namibia", "phone": "264", "length": 8 },
    { "code": "NC", "label": "New Caledonia", "phone": "687", "length": 8 },
    { "code": "NE", "label": "Niger", "phone": "227", "length": 8 },
    { "code": "NF", "label": "Norfolk Island", "phone": "672", "length": 7 },
    { "code": "NG", "label": "Nigeria", "phone": "234", "length": 10 },
    { "code": "NI", "label": "Nicaragua", "phone": "505", "length": 8 },
    { "code": "NL", "label": "Netherlands", "phone": "31", "length": 9 },
    { "code": "NO", "label": "Norway", "phone": "47", "length": 8 },
    { "code": "NP", "label": "Nepal", "phone": "977", "length": 10 },
    { "code": "NR", "label": "Nauru", "phone": "674", "length": 7 },
    { "code": "NU", "label": "Niue", "phone": "683", "length": 7 },
    { "code": "NZ", "label": "New Zealand", "phone": "64", "length": 9 },
    { "code": "OM", "label": "Oman", "phone": "968", "length": 8 },
    { "code": "PA", "label": "Panama", "phone": "507", "length": 8 },
    { "code": "PE", "label": "Peru", "phone": "51", "length": 9 },
    { "code": "PF", "label": "French Polynesia", "phone": "689", "length": 8 },
    { "code": "PG", "label": "Papua New Guinea", "phone": "675", "length": 8 },
    { "code": "PH", "label": "Philippines", "phone": "63", "length": 10 },
    { "code": "PK", "label": "Pakistan", "phone": "92", "length": 10 },
    { "code": "PL", "label": "Poland", "phone": "48", "length": 9 },
    { "code": "PM", "label": "Saint Pierre and Miquelon", "phone": "508", "length": 9 },
    { "code": "PN", "label": "Pitcairn Islands", "phone": "64", "length": 7 },
    { "code": "PR", "label": "Puerto Rico", "phone": "1-787", "length": 7 },
    { "code": "PT", "label": "Portugal", "phone": "351", "length": 9 }
]
